<template>
	<div>
		<Header />

		<div class="ifram">
			<iframe id="iframe" ref="dynamicIframe" :src="url" width="100%" frameborder="0"></iframe>

		</div>


		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import publicMethod from '@/views/publicMethod'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer

		},
		data() {
			return {
				url: '',
				resources: [{
						type: 'css',
						href: 'stock/libs/css/myAlert.min.css'
					},
					{
						type: 'js',
						src: 'stock/js/common.js'
					},
					{
						type: 'js',
						src: 'stock/libs/js/jquery.qrcode.min.js'
					},
					{
						type: 'js',
						src: 'stock/libs/js/myAlert.min.js'
					},
					{
						type: 'js',
						src: 'stock/js/noSecondLogin.js'
					},
					{
						type: 'js',
						src: 'stock/js/iframe.js'
					}
				]

			}
		},
		mounted() {

			const now = new Date();
			this.url = this.domain.testUrl + 'stock/introduce.html?id=' + window.channelId + '&v=' + now.getTime() + (
				localStorage.userToken ? '&ltoken=' + localStorage.userToken : '')

			sessionStorage.noSecondLogin = 2; //noSecondLogin=2不二次登录的标识
			sessionStorage.url = this.domain.partyDomain

			this.loadResources()


		},
		beforeDestroy() {
			console.log('股交所页面销毁了-------')
			window.location.reload();
		},
		methods: {


		}
	}
</script>

<style>
</style>